var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderLottery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M689.379556 164.882963a90.187852 90.187852 0 0 1 8.51437 162.285037l-161.28 88.310519 14.866963 35.46074-39.803259-21.788444-39.784297 21.807407 14.829037-35.460741-161.242074-88.329481a90.187852 90.187852 0 0 1-20.195555-15.075556l-3.489185-3.678814a90.187852 90.187852 0 1 1 150.205629-95.156149l59.676445 142.620445 59.695407-142.601482a90.187852 90.187852 0 0 1 118.006519-48.393481z",
    fill: "#FD6112",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M851.493926 351.004444a76.496593 76.496593 0 0 1 8.51437 152.519112v332.61037a75.851852 75.851852 0 0 1-75.851852 75.851852H554.002963V606.01837a34.000593 34.000593 0 0 0-68.001185 0v306.005334H255.848296a75.851852 75.851852 0 0 1-75.851852-75.851852l-0.018963-332.610371a76.515556 76.515556 0 0 1 8.533334-152.538074h662.983111z",
    fill: "#FD6112"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLottery);
export default __webpack_public_path__ + "static/media/order-lottery.85893dfef075864e46d2124ad0486435.svg";
export { ForwardRef as ReactComponent };